<template>
  <div class="page-content">
    <page-template ref="scalesTemplate"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
                   :addColumns="addColumns"
                   :editColumns="editColumns"
    ></page-template>
    <el-dialog title="批量修改PLU" :visible.sync="batchEditShow" width="800px" height="600px"
               :close-on-click-modal="false">
      <batch-update-p-l-u ref="batchEdit" :batchUpData="batchUpDateList"
                          :tableOptions="batchTableOptions"></batch-update-p-l-u>
      <div class="btn-box">
        <el-button @click="selectSubmit" type="primary">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import batchUpdatePLU from '@/components/business/batchUpdatePLU'
  import api from '@/config/api';

  export default {
    components: {
      pageTemplate,
      batchUpdatePLU
    },
    data() {
      return {
        batchEditShow: false,
        batchUpDateList: [],
        // 高级搜索条件
        searchOptions: {
          simple: [
            {label: '', prop: 'otherName', type: 'input', isFuzzy: true, placeholder: "商品条码/名称"},
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: '新增',
            code: 'insert',
          },
          {
            label: '批量修改',
            code: 'batchUpdatePLU',
            callback: this.batchEdit
          },
        ],
        // 表格信息配置
        tableOptions: {
          indexShow: true,//是否显示索引
          showSelect: true,
          param: {pricingMethod: 30},
          columns: [
            {label: '条码', prop: 'barCode', width: '120', align: 'center'},
            {label: '商品名称', prop: 'name', width: '120', align: 'center'},
            {label: '零售价', prop: 'retailPrice', width: '120', align: 'center'},
            {
              label: '计价方式',
              prop: 'pricingMethod',
              width: '120',
              align: 'center',
              enumData: this.$utils.getCacheStatus('asGoods.pricingMethod'),
            },
            {label: 'PLU码', prop: 'pluCode', width: '120', align: 'center'},
            {label: '操作人姓名', prop: 'lastModifyBy', width: '120', align: 'center'},
            {label: '操作时间', prop: 'lastModifyDttm', width: '120', align: 'center'},
          ],
          url: api.archives.goodsInfo
        },
        // 添加字段
        addColumns: {
          labelWidth: '350px',
          span: 24,
          columns: [
            {
              label: 'id',
              type: 'input',
              prop: 'id',
              hidden: true,
            },
            {
              label: '条码',
              type: 'select',
              prop: 'barCode',
              align: "center",
              data: [],
              url: api.archives.goodsInfo + '/no/plu/goods',
              param: {pricingMethod: 30}, // 称重商品
              labelKey: 'barCode',
              change: this.getGoodsName,
            },
            {
              label: '商品名称',
              type: 'input',
              prop: 'name',
              align: "center",
              disabled: true,
            },
            {
              label: 'PLU码',
              type: 'code',
              prop: 'pluCode',
              align: "center",
              url: api.archives.getPluCode,
              checkUrl: api.archives.verifyPluCode
            },
          ], // 表单label
          url: api.archives.goodsInfo + '/update/PLU'
        },
        // 编辑字段
        editColumns: {
          labelWidth: '350px',
          span: 24,
          columns: [
            {
              label: 'id',
              type: 'input',
              prop: 'id',
              hidden: true,
            },
            {
              label: '条码',
              type: 'select',
              prop: 'barCode',
              align: "center",
              data: [],
              url: api.archives.goodsInfo,
              param: {pricingMethod: 30}, // 称重商品
              labelKey: 'barCode',
              change: this.getGoodsName,
            },
            {
              label: '商品名称',
              type: 'input',
              prop: 'name',
              align: "center",
              disabled: true,
            },
            {
              label: 'PLU码',
              type: 'code',
              prop: 'pluCode',
              align: "center",
              url: api.archives.getPluCode,
              checkUrl: api.archives.verifyPluCode
            },
          ], // 表单label
          url: api.archives.goodsInfo
        },
        //批量修改
        batchTableOptions: {
          showSelect: true,
          indexShow: true,//是否显示索引
          indexMethod: (index) => {//自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '条码',
              prop: 'barCode',
              width: '150',
              align: 'center'
            },
            {
              label: "品名",
              prop: "goodsName",
              width: "100",
              align: "center"
            },
            {
              label: "PLU码",
              prop: "pluCode",
              width: "100",
              align: "center",
              type: "input"
            },
            // {
            //   label: 'PLU码',
            //   type: 'code',
            //   prop: 'pluCode',
            //   align: "center",
            //   url: api.archives.getPluCode,
            //   checkUrl: api.archives.verifyPluCode
            // },
          ],
          url: api.archives.goodsInfo
        },
      };
    },
    created() {
    },
    methods: {
      getGoodsName(data) {
        let barCodeIds = this.addColumns.columns.filter(item => item.prop === 'barCode')[0].data;
        barCodeIds.forEach(item => {
          // data.barCode 存的是id
          if (item.id === data.barCode) {
            data.name = item.name;
          }
        });
      },
      //批量修改
      batchEdit() {
        let tableSelected = this.$refs.scalesTemplate.getTableSelectRow();
        if (tableSelected.length === 0) {
          this.$message({message: '请勾选数据后进行批量修改', type: 'warning'});
        } else {
          this.batchEditShow = true;
          this.batchUpDateList = tableSelected;
          this.$nextTick(() => {
            this.$refs["batchEdit"].getTableData()
          })
        }
      },
      selectSubmit() {
        this.$axios.fetchPost('/api/eros/as/asGoods/batch/update/PLU', {asGoodsList: this.batchUpDateList}).then(data => {
          if (data.code === 200) {
            if (data.data === true) {
              this.batchEditShow = false;
              this.$refs["scalesTemplate"].operationSuccess();
            }
          }
        })
      },
    }
  };
</script>

<style scoped>
  .priceEdit {
    margin-left: 10px;
    margin-bottom: 20px;
  }
  .batch-btn{
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/page/archives/goods/Scales.vue